import {
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MyPATTextField } from '../../../common';

import { GeneralSettings as GeneralSettingsInterface, LocalePrice } from '../../types/interfaces/AdvancedSettings';

import getCountryList from '../../../userManagement/assets/countryListUtility';
import { CourseFor } from '../../types/enums/CourseForType';
import { FreeOrPaid } from '../../types/enums/FreeOrPaid';

import {
	Delete as DeleteIcon,
} from "@material-ui/icons";
import { courseStyles } from '../../styles';
import { TabVisited } from '../../types/interfaces/TabVisited';
import _ from 'lodash';
import { BUSINESS_TYPE } from '../../Constants/constants';


enum RadioType {
  paidOrfree = 'Paid or Free',
  sellsOutsideIndia = 'Sells Outside India'
}
interface Props extends WithStyles<typeof courseStyles> {
  generalSettings: GeneralSettingsInterface;
  handleGeneralSettings: (generalSettings: GeneralSettingsInterface) => void;
  classes: any;
  checkFormErrors: (formErrors: any) => void;
  isPreview: boolean;
  disableFields:boolean
  tabVisited: TabVisited
  setTabVisited: Function
  isPublishBtnClicked: boolean
  checkGeneralSettingsMandatoryFields: Function
}

interface State {
  // generalSettings: GeneralSettingsInterface;
  formErrors: any
}

class GeneralSettings extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // const { defaultValues } = this.props;
    this.state = {
      formErrors: {
        discount: this.props.generalSettings.sellsOutsideIndia ? '' : '',
        price: this.props.tabVisited.generalSettings ? '' : (this.props.generalSettings.sellsOutsideIndia ? '' : 'Price cannot be 0'),
        localWisePriceErrors: this.props.tabVisited.generalSettings ? this.generateInitialErrorsFromLocaleWisePrice() : (this.props.generalSettings.sellsOutsideIndia  ? ['Price cannot be 0']:['']),
        localWiseDiscountErrors:this.props.generalSettings.sellsOutsideIndia ? this.generateInitialErrorsFromLocaleWisePrice() : ['']
      }
    }
  
  }

  generateInitialErrorsFromLocaleWisePrice = () => {
    const { generalSettings: { localeWisePrice } } = this.props;
    if(!localeWisePrice) {
      return ['']
    }
    return localeWisePrice.map(() => '');
  }

  componentDidMount = () => {
    this.props.checkFormErrors(this.state.formErrors)
    this.props.setTabVisited('generalSettings')
    this.props.checkGeneralSettingsMandatoryFields(this.props.generalSettings)
  };

  getSupportedCountryList = () => {
    const supportedCountryList = [
            {
              alpha3: 'IN',
              name: 'India',
              dialCode: '+91',
              class: 'India',
              currency: 'INR',
              regex: '^[6-9]\\d{9}$',
              flag: 'http://fb1-v4.mypat.in/assets/images/country-flags/india.png'
            },
            {
              alpha3: 'AE',
              name: 'United Arab Emirates',
              dialCode: '+971',
              class: 'UnitedArabEmirates',
              currency: 'AED',
              regex: '^(5[02468]{1})[1-9]{1}[0-9]{6}$',
              flag: 'http://fb1-v4.mypat.in/assets/images/country-flags/united-arab-emirates.png'
            }
      ];
  return supportedCountryList
  }

  getCurrencyFromAplha3 = (alpha3: string) => {
    const supportedCountry = this.getSupportedCountryList();
    const country = supportedCountry.find(country => country.alpha3 === alpha3);

    return _.get(country, 'currency', '');
  }

  getCountryItemsList = (index: number) => {
    // const countryList = getCountryList();
    const countryList = this.getSupportedCountryList();
    const { classes } = this.props;
    const { generalSettings: {localeWisePrice}} = this.props;
    const alreadySelectedCountryCodes =localeWisePrice ?  localeWisePrice.map((item) => item.locale) : [];
    
    // const selectedValue = localeWisePrice && localeWisePrice[index].locale
    const selectedValue = _.get(localeWisePrice, `[${index}].locale`, '')
    const countryListMenuItems = countryList.map((country: any, index: any) => {
      const alpha3 =  country.alpha3;
      if(alpha3 !== selectedValue && alreadySelectedCountryCodes.includes(alpha3)){
        return null;
      }

      return (
        <MenuItem
          key={alpha3}
          value={alpha3}
          // className={classes.menuItem}

        >
          <img src={country.flag} />
          {/* {country.dialCode} */}
        </MenuItem>
      );
    });

    return countryListMenuItems;
  };

  handleCountryCodeChange = (event: any, index: number) => {
    const countryCode = event.target.value;
    // const formData = this.state.formData;
    // formData.user.mobile.countryCode = countryCode;
    // this.setState({ ...this.state, formData });
  
    const { generalSettings, generalSettings:{sellsOutsideIndia, localeWisePrice = []} } = this.props;
    let updatedGeneralSettings = {...generalSettings};
    let updatedLocalWisePrice = [...localeWisePrice];
   
    if(sellsOutsideIndia){
      let objectToUpdate = {...updatedLocalWisePrice[index]}
      objectToUpdate.locale = countryCode;
      updatedLocalWisePrice[index] = objectToUpdate;
      updatedGeneralSettings.localeWisePrice = updatedLocalWisePrice;
    }

    this.props.handleGeneralSettings(updatedGeneralSettings);


  };

  getPriceRow = (index: number = 0, country?: LocalePrice) => {
    const countryListItems = this.getCountryItemsList(index);
    const { classes,disableFields,isPreview } = this.props;
    const {
      generalSettings: { sellsOutsideIndia = false, localeWisePrice },
    } = this.props;
   return (
      <Grid container spacing={16} className="AddRow">  
        <Grid item xs={12}>
          <Grid container spacing={8} className={classes.posRelative}>        
              <Grid item xs={6}>
               {this.props.generalSettings.sellsOutsideIndia && <span className={classes.countryFlag}>
                  <FormControl>
                    <Select
                      value={this.props.generalSettings.sellsOutsideIndia ? 
                        this.props.generalSettings.localeWisePrice &&
                        this.props.generalSettings.localeWisePrice[index] &&
                        this.props.generalSettings.localeWisePrice[index].locale :
                        'IN'
                      }
                      onChange={(e) => this.handleCountryCodeChange(e, index)}
                      displayEmpty
                      name="countryCode"
                      disabled={!sellsOutsideIndia || disableFields || isPreview}
                      disableUnderline={true}
                      // classes={{ root: classes.customSelect }}
                    >
                      {countryListItems}
                    </Select>
                  </FormControl>
                </span>}
                <MyPATTextField
                  className={this.props.generalSettings.sellsOutsideIndia ? classes.coursePrice : classes.coursePriceJustIndia}
                  fullWidthControl
                  // className={[
                  //   classes.customInput,
                  //   classes.inputWidth,
                  // ].join(' ')}
                  inputId="price"
                  name="price"
                  placeholder={
                    this.props.generalSettings.sellsOutsideIndia ? 
                   this.getCurrencyFromAplha3(_.get(this.props.generalSettings, `localeWisePrice[${index}].locale`,'')) :
                    'INR'
                  }
                   disabled={disableFields || isPreview}
                  value={ this.props.generalSettings.sellsOutsideIndia ?
                          this.props.generalSettings.localeWisePrice &&
                          this.props.generalSettings.localeWisePrice[index] &&
                          (
                            this.props.generalSettings.localeWisePrice[index].price > 1 ?
                            this.props.generalSettings.localeWisePrice[index].price : 
                            null
                          ) :
                          (
                            this.props.generalSettings.price !== 0 ? 
                            this.props.generalSettings.price : 
                            null
                          )
                          }
                  onChange={(e:any) => this.handleChange(e, index)}
                  error={
                    this.props.generalSettings.sellsOutsideIndia && 
                    (this.state.formErrors.localWisePriceErrors[index] || this.state.formErrors.price)
                  }
                  errorText={
                    this.props.generalSettings.sellsOutsideIndia?
                    this.state.formErrors.localWisePriceErrors[index] :
                    this.state.formErrors.price
                  }
                  type="number"
                  endAdornment={<></>}
                />
              </Grid>
              <Grid item xs={6}>
                <MyPATTextField
                  // className={classes.inputWidth}
                  fullWidthControl
                  // className={[
                  //   classes.customInput,
                  //   classes.inputWidth,
                  // ].join(' ')}
                  inputId="discount"
                  name="discount"
                  placeholder="Enter Percentage"
                   disabled={disableFields || isPreview}
                  value={
                    this.props.generalSettings.sellsOutsideIndia ?
                    this.props.generalSettings.localeWisePrice &&
                    this.props.generalSettings.localeWisePrice[index] &&
                    this.props.generalSettings.localeWisePrice[index].discount :
                    this.props.generalSettings.discount
                  }
                  onChange={(e:any) => this.handleChange(e, index)}
                  error={
                    this.props.generalSettings.sellsOutsideIndia &&
                    (this.state.formErrors.localWiseDiscountErrors[index] || this.state.formErrors.discount)
                    
                  }
                  errorText={
                    this.props.generalSettings.sellsOutsideIndia ?
                    this.state.formErrors.localWiseDiscountErrors[index] :  
                    this.state.formErrors.discount
                  
                  }
                  type="number"
                  endAdornment={<></>}
                />
              </Grid>
            {this.props.generalSettings.sellsOutsideIndia  && (index > 0) && <Grid item xs={2}>
           {(disableFields || isPreview)?(
            <span className={classes.DeleteCTA}>
                {/* <DeleteIcon /> */}
                  <img src="/assets/svg/myLibrary/delete-outline.svg"/>
              </span>
           ):(
              <span onClick={() => this.removePriceRow(index)} className={classes.DeleteCTA}>
                {/* <DeleteIcon /> */}
                  <img src="/assets/svg/myLibrary/delete-outline.svg"/>
              </span>
           )

           }   
            </Grid>}
          </Grid>
        </Grid>
      </Grid>
    );
  }

  renderPriceRows = () => {
    const {
      generalSettings: { sellsOutsideIndia = false },
    } = this.props;
    

    if (sellsOutsideIndia) {
      const { generalSettings : { localeWisePrice = [] }} = this.props;
      return localeWisePrice.map((country, index) => this.getPriceRow(index, country))
    } else {
      return this.getPriceRow()
    }
  };


  getNewPriceRow = () => {
    const { generalSettings: { localeWisePrice = [] } } = this.props;
     const newPriceRow:LocalePrice = {
      locale:'',
      price:0,
      discount:0
    }
    const supportedCountryList = this.getSupportedCountryList();

    // if only one country left to select then auto select its locale
    if(localeWisePrice.length === supportedCountryList.length - 1) {
      const remainingCountry = supportedCountryList.find(country => !localeWisePrice.find(({ locale }) => locale === country.alpha3));
      if(remainingCountry) {
        // setting remainingCountry's alpha3 to newPriceRow locale for auto selection
        newPriceRow.locale = remainingCountry.alpha3;
      }
    }
    return newPriceRow
  }

  addPriceRow = () => {
    const newPriceRow = this.getNewPriceRow();
    const newPriceError = '';
    const newDiscountError = '';

    let { generalSettings, generalSettings:{localeWisePrice = []} } = this.props;

    let updatedFormErrors  = {...this.state.formErrors};

    let newLocalWisePriceErrors = [...this.state.formErrors.localWisePriceErrors];
    newLocalWisePriceErrors.push(newPriceError);
    updatedFormErrors.localWisePriceErrors = newLocalWisePriceErrors;

    let newLocalWiseDiscountErrors = [...this.state.formErrors.localWiseDiscountErrors];
    newLocalWiseDiscountErrors.push(newDiscountError);
    updatedFormErrors.localWiseDiscountErrors = newLocalWiseDiscountErrors;

    let updatedLocaleWisePrices = [...localeWisePrice];
    let updatedGeneralSettings = { ...generalSettings };
    updatedLocaleWisePrices && updatedLocaleWisePrices.push(newPriceRow);
    updatedGeneralSettings.localeWisePrice = updatedLocaleWisePrices;
    this.props.handleGeneralSettings(updatedGeneralSettings);
    this.setState({
      formErrors: updatedFormErrors
    }
    )
  };

  removePriceRow = (index: number) => {
    // let updatedLocalWisePrices = this.state.generalSettings.localeWisePrice;
    let { generalSettings, generalSettings:{localeWisePrice=[]} }  = this.props;
    let updatedGeneralSettings = {...generalSettings};
    let updatedLocalWisePrices = [...localeWisePrice];
    // updatedLocalWisePrices = updatedLocalWisePrices && updatedLocalWisePrices.splice(index, 1);
    updatedLocalWisePrices = updatedLocalWisePrices.filter((localPrice, idx) => idx !== index);
    updatedGeneralSettings.localeWisePrice = updatedLocalWisePrices;

    let updatedFormErrors  = {...this.state.formErrors};

    let newLocalWisePriceErrors = [...this.state.formErrors.localWisePriceErrors];
    newLocalWisePriceErrors = newLocalWisePriceErrors.filter((localPriceError, idx) => idx !== index);
    updatedFormErrors.localWisePriceErrors = newLocalWisePriceErrors;

    let newLocalWiseDiscountErrors = [...this.state.formErrors.localWiseDiscountErrors];
    newLocalWiseDiscountErrors = newLocalWiseDiscountErrors.filter((localDiscountError, idx) => idx !== index);
    updatedFormErrors.localWiseDiscountErrors = newLocalWiseDiscountErrors;

    this.props.handleGeneralSettings(updatedGeneralSettings);
    this.setState({
      formErrors: updatedFormErrors
    })
  };

  handleToggle = (type: string) => {
    let { generalSettings, generalSettings:{availableForB2C, availableForTestUsers} } = this.props;
    let updatedGeneralSettings = {...generalSettings};
    switch(type){
      case CourseFor.b2c:
        let updatedAvailableForB2C = availableForB2C;
        let updatedAvailableForTestUsersCopy = availableForTestUsers;
        updatedAvailableForB2C = !updatedAvailableForB2C;
        updatedAvailableForTestUsersCopy = !updatedAvailableForTestUsersCopy;
        updatedGeneralSettings.availableForB2C = updatedAvailableForB2C;
        updatedGeneralSettings.availableForTestUsers = updatedAvailableForTestUsersCopy;
        break;
      case CourseFor.testUsers:
        let updatedAvailableForTestUsers = availableForTestUsers;
        updatedAvailableForTestUsers = !updatedAvailableForTestUsers;
        updatedGeneralSettings.availableForTestUsers = updatedAvailableForTestUsers;
        break;
      default:
    }
    this.props.handleGeneralSettings(updatedGeneralSettings)

  }

  handleRadio = (type: string) => {
    const { generalSettings, generalSettings: {isPaid, sellsOutsideIndia} } = this.props;
    let updatedGeneralSettings = {...generalSettings};
    let updatedIsPaid = isPaid;
    let updatedSellsOutsideIndia = sellsOutsideIndia;
    switch(type){
      case RadioType.paidOrfree:
        if (updatedIsPaid === FreeOrPaid.free) {
          updatedIsPaid = FreeOrPaid.paid;
        } else {
          updatedIsPaid =  FreeOrPaid.free;
        }
        updatedGeneralSettings.isPaid = updatedIsPaid;
        break;
      case RadioType.sellsOutsideIndia:
        updatedSellsOutsideIndia = !updatedSellsOutsideIndia;
        updatedGeneralSettings.sellsOutsideIndia = updatedSellsOutsideIndia;
        break;
      default:
    }
    this.props.handleGeneralSettings(updatedGeneralSettings);
  }

  handleChange = (e:any, index: number = 0) => {
    const {name, value} = e.target;
    const {generalSettings, generalSettings: {otherInfo, sellsOutsideIndia, localeWisePrice = []}} = this.props;
    let updatedGeneralSettings = {...generalSettings};
    let updatedLocalWisePrice = [...localeWisePrice];
    let updatedOtherInfo = {...otherInfo};
    switch(name){
      case 'mainTest':
        updatedOtherInfo.mainTests = value;
        updatedGeneralSettings.otherInfo = updatedOtherInfo;
        break;
      case 'conceptTest':
        updatedOtherInfo.conceptTests = value;
        updatedGeneralSettings.otherInfo = updatedOtherInfo;
        break;
      case 'price':
        if (sellsOutsideIndia) {
          if(value.toString().length <= 6) {
            let objectToUpdate = {...updatedLocalWisePrice[index]};
            objectToUpdate.price = value;
            // updatedLocalWisePrice[index].price = value;
            updatedLocalWisePrice[index] = objectToUpdate;
            updatedGeneralSettings.localeWisePrice = updatedLocalWisePrice;
            let updatedFormErrors = {...this.state.formErrors};
            let updatedLocalWisePriceErrors = [...this.state.formErrors.localWisePriceErrors];
            if(value < 1) {
              updatedLocalWisePriceErrors[index] = 'Price cannot be 0 or less than 0 for paid course.';
              updatedFormErrors.localWisePriceErrors = updatedLocalWisePriceErrors
              this.setState({
                formErrors: updatedFormErrors
              })
              this.props.checkFormErrors(updatedFormErrors);
            } else {
              updatedLocalWisePriceErrors[index] = '';
              updatedFormErrors.localWisePriceErrors = updatedLocalWisePriceErrors;
              this.setState({
                formErrors: updatedFormErrors
              })
              this.props.checkFormErrors(updatedFormErrors)
            }
          }
        } else {
          if(value.toString().length <= 6) {
            updatedGeneralSettings.price = value;
            let updatedFormErrorsPrice = {...this.state.formErrors};
            if(value < 1){
              updatedFormErrorsPrice.price = 'Price cannot be 0 or less than 0 for paid course.';
              this.setState({
                formErrors: updatedFormErrorsPrice
              })
              this.props.checkFormErrors(updatedFormErrorsPrice);
            } else {
              updatedFormErrorsPrice.price = '';
              this.setState({
                formErrors: updatedFormErrorsPrice
              })
              this.props.checkFormErrors(updatedFormErrorsPrice);
            }
          }
        }
        this.props.checkGeneralSettingsMandatoryFields(this.props.generalSettings)
        break;
      case 'discount':
        if(sellsOutsideIndia) {
         if((value.toString().length <=3) && (+value >=0 && +value <=100)) {
            let objectToUpdate = {...updatedLocalWisePrice[index]};
            objectToUpdate.discount = value;
            // updatedLocalWisePrice[index].discount = value;
            updatedLocalWisePrice[index] = objectToUpdate;
            updatedGeneralSettings.localeWisePrice = updatedLocalWisePrice;
            let updatedFormErrors = {...this.state.formErrors};
            let updatedLocalWiseDiscountErrors = [...this.state.formErrors.localWiseDiscountErrors];
            if(value < 0 || value > 100){
              updatedLocalWiseDiscountErrors[index] = 'Discount cannot be greater than 100 or less than 0';
              updatedFormErrors.localWiseDiscountErrors = updatedLocalWiseDiscountErrors;
              this.setState({
                formErrors: updatedFormErrors
              })
              this.props.checkFormErrors(updatedFormErrors)
            } else {
              updatedLocalWiseDiscountErrors[index] = '';
              updatedFormErrors.localWiseDiscountErrors = updatedLocalWiseDiscountErrors;
              this.setState({
                formErrors: updatedFormErrors
              })
              this.props.checkFormErrors(updatedFormErrors)
            }
         }
        } else {
          if((value.toString().length <=3) && (+value >=0 && +value <=100)) {
            updatedGeneralSettings.discount = value;
            let updatedFormErrors = {...this.state.formErrors};
            if(value < 0 || value > 100){
              updatedFormErrors.discount = 'Discount cannot be greater than 100 or less than 0';
              this.setState({
                formErrors: updatedFormErrors
              })
              this.props.checkFormErrors(updatedFormErrors);
            } else {
              updatedFormErrors.discount = '';
              this.setState({
                formErrors: updatedFormErrors
              })
              this.props.checkFormErrors(updatedFormErrors);
            }
          }
        }

      default:
    }
    this.props.handleGeneralSettings(updatedGeneralSettings);
  }
  handleBusinessType(type: string) {
    const { generalSettings } = this.props;
    let updatedGeneralSettings: any = { ...generalSettings };
    updatedGeneralSettings[type] = !updatedGeneralSettings[type];
    this.props.handleGeneralSettings(updatedGeneralSettings);
  }
  checkForBusinessType(generalSettings: any, type: string) {
    return generalSettings[type];
  }

  render() {
    const { classes,disableFields,isPreview } = this.props; 
    return (
      <Grid container spacing={8} justify="flex-start">
        <Grid item xs={12}>
          <Card className={[classes.cardPadding, classes.paddingBottom85].join(' ')}>
            <Grid container spacing={8} justify="flex-start">
              <Grid item xs={8}>
                <Grid container justify="flex-start" alignItems="center">
                  <Grid item className={classes.switchCustom}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                          classes={{
                            root: classes.swithMain,
                            icon: classes.switchIcon,
                            bar: classes.switchBar,
                            iconChecked: classes.IscheckedSwitch,
                            checked: classes.checkedSwitch,
                            // disabled: classes.disabledSwitch
                        }}
                            color="primary"
                            checked={this.props.generalSettings.availableForB2C}
                          onChange={() => this.handleToggle(CourseFor.b2c)}
                          disabled={disableFields || isPreview}
                          />
                        }
                        label="Publish on Glorifire.com"
                        labelPlacement="start"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item className={classes.switchCustom2}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                          classes={{
                            root: classes.swithMain,
                            icon: classes.switchIcon,
                            bar: classes.switchBar,
                            iconChecked: classes.IscheckedSwitch,
                            checked: classes.checkedSwitch,
                          }}
                          color="primary"
                          checked={this.props.generalSettings.availableForTestUsers}
                          onChange={() => this.handleToggle(CourseFor.testUsers)}
                          disabled={disableFields || isPreview}
                          />
                        }
                        label="Publish for test users only"
                        labelPlacement="start"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
                {/* Paid and Free */}
                <Grid container justify="flex-start">
                  <Grid item xs={4}>
                    <RadioGroup
                      className={classes.courseRadioGroup}
                      aria-label="freeOrPaid"
                      name="freeOrPaid"
                      defaultValue="Paid"
                      value={this.props.generalSettings.isPaid}
                      onChange={() => this.handleRadio(RadioType.paidOrfree)}
                      style={{ flexDirection: 'row' }}
                    >
                    <FormControlLabel value="Free" control={<Radio color="primary"/>} label="Free" disabled={disableFields || isPreview}/>
                    <FormControlLabel
                      style={{ marginLeft: '50px', fontSize: '28px' }}
                      value="Paid"
                      control={<Radio color="primary"/>}
                      label="Paid"
                      disabled={disableFields || isPreview}
                    />
                    </RadioGroup>
                  </Grid>
                </Grid>
                {/* Yes No */}
                { this.props.generalSettings.isPaid === 'Paid' && <Grid container justify="flex-start" alignItems="center" className={classes.mb15}>
                  <Grid item>
                    <Typography className={[classes.labelTxt, classes.mr27].join(' ')}>Course sells outside India:</Typography>
                  </Grid>
                  <Grid item>                
                    <RadioGroup
                      className={classes.courseRadioGroup}
                      aria-label="yesOrNo"
                      name="yesOrNo"
                      defaultValue="No"
                      value={this.props.generalSettings.sellsOutsideIndia?"Yes":"No"}
                      onChange={() => this.handleRadio(RadioType.sellsOutsideIndia)}
                      style={{ flexDirection: 'row' }}
                    >
                      <FormControlLabel value="Yes" control={<Radio color="primary"/>} label="Yes" disabled={disableFields || isPreview} />
                      <FormControlLabel
                        style={{ marginLeft: '50px', fontSize: '28px' }}
                        value="No"
                        control={<Radio color="primary"/>}
                        label="No"
                        disabled={disableFields || isPreview}
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>}
                {/* Price and discount */}
                {this.props.generalSettings.isPaid === 'Paid' && <Grid container justify="flex-start" alignItems="center" spacing={32} className={classes.mb15}>
                  <Grid item xs={10}>
                    <Grid container spacing={8} className={classes.AddRowContainer}>
                      <Grid item xs={6}>
                        <Typography className={classes.labelTxt}>Course Price<span>*</span></Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography className={classes.labelTxt}>Discount (%)</Typography>
                      </Grid>
                      {this.renderPriceRows()}
                      { this.props.generalSettings.sellsOutsideIndia && 
                      this.props.generalSettings.localeWisePrice &&
                       this.props.generalSettings.localeWisePrice.length < 2 && !isPreview && <Grid container justify="flex-end" alignItems="center">
                        <Grid item className={classes.AddPriceCTA} >
                            <span onClick={() => this.addPriceRow()}>
                              + Add Price
                            </span>
                        </Grid>
                      </Grid>
                      }
                    </Grid>
                  </Grid>
                </Grid>}
                {/* Main Test concept test */}
                <Grid container justify="flex-start" alignItems="center" spacing={32}>
                  <Grid item xs={10}>
                    <Grid container spacing={16}>
                      <Grid item xs={6}>
                      <Typography className={classes.labelTxt}>Main Test Info Icon</Typography>
                        <MyPATTextField
                            // className={classes.test}
                          fullWidthControl
                          // inputId="name"
                          name="mainTest"
                          placeholder="Enter Main Test info icon text"
                         disabled={disableFields || isPreview}
                          value={_.get(this.props.generalSettings, 'otherInfo.mainTests', '')}
                          onChange={(e:any) => this.handleChange(e)}
                          // error={}
                          // errorText={}
                        />
                      </Grid>
                      <Grid item xs={6}>
                      <Typography className={classes.labelTxt}>Concept Test Info Icon</Typography>
                        <MyPATTextField
                          //   className={classes.inputWidth}
                          fullWidthControl
                          // inputId="name"
                          name="conceptTest"
                          placeholder="Enter Package Name"
                          disabled={disableFields || isPreview}
                          value={_.get(this.props.generalSettings,'otherInfo.conceptTests', '')}
                          onChange={(e:any) => this.handleChange(e)}
                          // error={}
                          // errorText={}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                
                <Grid className={classes.businessTypeRow}>
                  <Grid className={classes.labelText} container spacing={32}>
                    <Typography className={classes.labelTxt}> Business Type: </Typography>
                  </Grid>
                  {BUSINESS_TYPE.map((type: any, index: number) =>
                    <FormControlLabel className='labelBox'
                      control={
                        <Checkbox
                          classes={{
                            root: classes.checkBoxElement,
                            checked: classes.checkedCheckbox + ' clickedCheckbox',
                            colorPrimary: classes.primaryColor
                          }}
                          disabled={disableFields || isPreview}
                          checked={this.checkForBusinessType(this.props.generalSettings, type.VALUE)}
                          color='primary'
                          value={type.VALUE}
                          onChange={() => this.handleBusinessType(type.VALUE)}
                          key={index}
                        />
                      }
                      label={type.LABEL}
                      classes={{ root: classes.formControlLabel }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(GeneralSettings));
